export const tourGuideSteps = [
  {
    selector: "#client-details-card",
    content:
      "This area shows the summary of the client details.",
  },
  {
    selector: "#connector-details",
    content:
      "Provides connector level detail of the message.",
  },
  {
    selector: "#message-details",
    content:
      "This is the raw message content that was archived.",
  },
  {
    selector: "#attachment-details",
    content:
      "This is the attachment data associated with the message.",
  },
  {
    selector: "#metadata-details",
    content:
      "This is the channel metadata associated with the message.",
  },
  {
    selector: "#reprocess-message-button",
    content:
      "Press this button to reprocess the archived message.",
  },
];
